import { render } from "./pagination.vue?vue&type=template&id=cb214aa4&scoped=true&ts=true"
import script from "./pagination.vue?vue&type=script&lang=ts"
export * from "./pagination.vue?vue&type=script&lang=ts"

import "./pagination.vue?vue&type=style&index=0&id=cb214aa4&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/www.soyoung.com-vue3-pc-master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb214aa4"]])

export default __exports__